module.exports = __webpack_public_path__ + "img/info_detail.23f56618.png";